/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import i18n from '@fai/friendli-suite/features/i18n';
import Paths from '@fai/friendli-suite/features/routes/paths';

export const getProductLinksWithLabel = (teamId: string) => [
  {
    label: i18n.t('layout.serverless_endpoints'),
    path: Paths.team(teamId).serverlessEndpoints.default,
  },
  {
    label: i18n.t('layout.dedicated_endpoints'),
    path: Paths.team(teamId).dedicatedEndpoints.default,
  },
  {
    label: i18n.t('layout.container'),
    path: Paths.team(teamId).container.default,
  },
];
